<script>
import Layout from "../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import {filter} from "../../helpers/Vue-Filter";
import DatePicker from "vue2-datepicker";

import "vue2-datepicker/locale/ja";
import "vue2-datepicker/locale/en";

import {configComputed, configMethods, hospitalComputed, hospitalMethods} from "@/state/helpers";
import Loader from "../../components/widgets/loader.vue";

export default {
  /* eslint-disable no-console */

  filters: {
    ...filter,
  },

  page: {
    title: "会員一覧",
    meta: [{name: "description", content: appConfig.description}],
  },

  components: {Layout, PageHeader, DatePicker, Multiselect, Loader},

  data() {
    return {
      filter: {},
      filterOn: [],
      sortBy: "age",
      sortDesc: false,

      dataInsert: {},
      dataUpdate: {},
      pagination: {
        current_page: 1,
        total: 20,
        per_page: 20,
      },
      loader: false,
      valueSelectStatus: null,
      valueSelectSex: null,
      page: 1,
      paginationPages: 5,
    };
  },

  created() {
    try {
      this.loader = true;
      this.getConfig();
      this.fetchHospital(Object.assign({}, {role: "user", page: 1}));
      this.pagination = Object.assign(this.gPaginationHospital, {});
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(
        function () {
          this.loader = false;
        }.bind(this),
        1000
      );
    }
  },

  watch: {
    gPaginationHospital: {
      handler(value) {
        this.pagination = Object.assign(value, {});
        this.paginationPages = value.last_page;
      },
      deep: true,
    },
  },

  computed: {
    ...hospitalComputed,
    ...configComputed,
  },

  methods: {
    ...hospitalMethods,
    ...configMethods,

    field() {
      return [
        {key: "#", sortable: true},
        {
          key: "user_id",
          label: this.$t("menuitems.hospital.userId"),
          sortable: true,
        },
        {
          key: "information.fullname",
          label: this.$t("menuitems.hospital.fullname"),
          sortable: true,
        },
        {
          key: "information.birthday",
          label: this.$t("menuitems.hospital.dateOfBirth"),
          sortable: true,
        },
        {
          key: "information.age",
          label: this.$t("menuitems.hospital.age"),
          sortable: true,
        },
        {
          key: "sex",
          label: this.$t("menuitems.hospital.sex"),
          sortable: true,
        },
        {
          key: "loco7",
          label: this.$t("menuitems.hospital.loco7"),
          sortable: true,
        },
        {
          key: "loco25",
          label: this.$t("menuitems.hospital.loco25"),
          sortable: true,
        },
        {
          key: "hipscore",
          label: this.$t("menuitems.hospital.hipscore"),
          sortable: true,
        },
        {
          key: "frequency",
          label: this.$t("menuitems.hospital.frequency"),
          sortable: true,
        },
        {
          key: "status",
          label: this.$t("menuitems.hospital.status"),
          sortable: true,
        },
      ];
    },

    async handlerSearch() {
      try {
        this.loader = true;
        this.page = 1;
        const payloadSearch = Object.assign(
          {role: "user", page: this.page},
          this.filter
        );
        payloadSearch.birthday = payloadSearch.birthday
          ? filter.fomatDate(payloadSearch.birthday, "YYYY/MM/DD")
          : null;
        await this.fetchHospital(payloadSearch);
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(
          function () {
            this.loader = false;
          }.bind(this),
          1000
        );
      }
    },

    async handlerSubmit() {
      try {
        const respon = await this.post(this.dataInsert);
        console.log(respon);
      } catch (error) {
        console.log(error);
      }
    },

    async handlerUpdate() {
      try {
        const respon = await this.update(this.dataUpdate);
        console.log(respon);
      } catch (error) {
        console.log(error);
      }
    },

    async handlerDelete() {
      try {
        const respon = await this.del();
        console.log(respon);
      } catch (error) {
        console.log(error);
      }
    },

    async handlerApproved() {
      try {
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to approve?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, approve it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const respon = await this.approved();
            if (respon.status === 200) {
              this.alertSuccess();
              this.fetchHospital();
            }
            if (respon.status !== 200) {
              this.alertError(respon.status);
              return;
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    selectFilterStatus(context) {
      if (!context) return;
      this.filter.status = context.value;
    },

    selectFilterSex(context) {
      if (!context) return;
      this.filter.sex = context.value;
    },

    OnPagination(page) {
      try {
        this.loader = true;
        this.page = page;
        this.fetchHospital(
          Object.assign(this.filter, {role: "user", page: this.page})
        );
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(
          function () {
            this.loader = false;
          }.bind(this),
          1000
        );
      }
    },

    async handlerReject() {
      try {
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to reject?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, reject it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const respon = await this.reject();
            if (respon.status === 200) {
              this.alertSuccess();
              this.fetchHospital();
            }
            if (respon.status !== 200) {
              this.alertError(respon.status);
              return;
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    showModalEdit() {
    },
  },
};
</script>

<template>
  <Layout class="kurua-page">
    <PageHeader :title="$t('menuitems.hospital.title')" />
    <div class="card">
      <div class="col-12 p-4">
        <h5>{{ $t("menuitems.hospital.filter") }}</h5>
        <hr />
        <div class="row">
          <div class="col-md-3">
            <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.userId')" label-for="userId">
              <b-form-input type="search" v-model="filter.user_id" :placeholder="$t('menuitems.hospital.placeholderUserId')" for="userId" value="" class="helo" :maxlength="256"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.fullname')" label-for="fullname">
              <b-form-input type="search" v-model="filter.fullname" :placeholder="$t('menuitems.hospital.placehoderUsernameKana')" for="fullname" value="" class="helo" :maxlength="256"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.sex')" label-for="sex">
              <multiselect for="sex" v-model="valueSelectSex" label="label" @select="selectFilterSex" :show-labels="false" track-by="value" :options="gGetConfig.gender || []" class="helo" :placeholder="$t('menuitems.hospital.placehoderGender')"></multiselect>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.dateOfBirth')" label-for="生年月日">
              <date-picker for="生年月日" v-model="filter.birthday" :first-day-of-week="1" :placeholder="$t('menuitems.hospital.placehoderDateOfBirth')" lang="ja" confirm class="helo"></date-picker>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.age')" label-for="age">
              <b-form-input type="number" min="1" max="100" v-model.number="filter.age" :placeholder="$t('menuitems.hospital.placehoderAge')" for="age" value="" class="helo"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.status')" label-for="status">
              <multiselect for="status" track-by="value" v-model="valueSelectStatus" label="label" :show-labels="false" @select="selectFilterStatus" :options="gGetConfig.user_status || []" class="helo" :placeholder="$t('menuitems.hospital.placehoderStatus')"></multiselect>
            </b-form-group>
          </div>
          <div class="col-3 text-white">
            <div class="row">
              <div class="col-6">
                <b-form-group label="0000">
                  <b-button @click="handlerSearch()" v-b-modal.modal-lg class="btn-lyg w-100 pl-1 pr-1">
                    {{ $t("menuitems.hospital.search") }}
                  </b-button>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group label="0000">
                  <b-button class="btn-outline-lyg w-100" @click="
                      ((filter = {}),
                      (valueSelectStatus = null),
                      (valueSelectSex = null)),
                        handlerSearch()
                    " v-b-modal.modal-lg>
                    {{ $t("menuitems.hospital.clearFilter") }}
                  </b-button>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card p-4">
      <h5 class="card-title mb-3">
        {{ $t("menuitems.hospital.members") }}: {{ pagination.total }}
        {{ $t("menuitems.hospital.people") }} ({{ $t("menuitems.hospital.inUse")
        }}: {{ pagination.per_page }} {{ $t("menuitems.hospital.people") }})
      </h5>
      <Loader :loading="loader">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table">
              <thead class="table-light">
              <tr>
                <th class="text-center">
                  {{ $t("menuitems.hospital.userId") }}
                </th>
                <th class="text-center">
                  {{ $t("menuitems.hospital.fullname") }}
                </th>
                <th class="text-center">
                  {{ $t("menuitems.hospital.dateOfBirth") }}
                </th>
                <th class="text-center">
                  {{ $t("menuitems.hospital.age") }}
                </th>
                <th class="text-center">
                  {{ $t("menuitems.hospital.sex") }}
                </th>
                <th class="text-center">
                  {{ $t("menuitems.hospital.loco7") }}
                </th>
                <th class="text-center">
                  {{ $t("menuitems.hospital.loco25") }}
                </th>
                <th class="text-center">
                  {{ $t("menuitems.hospital.hipscore") }}
                </th>
                <th class="text-center">
                  {{ $t("menuitems.hospital.frequency") }}
                </th>
                <th class="text-center">
                  {{ $t("menuitems.hospital.status") }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr class="text-center" v-for="(hospital, index) in gHospitals" :key="index">
                <td class="p-4 text-table text-truncate">
                  <a class="text-link" href="javascript: void(0);" @click="$router.push(`/hospital/users/${hospital.uuid}`)">
                    {{ hospital.patient_id }}
                  </a>
                </td>
                <td class="p-4 text-table">
                  {{ hospital.information
                  ? hospital.information.fullname
                  : "Null"
                  }}
                </td>
                <td class="p-4 text-table">
                  {{ hospital.information
                  ? hospital.information.birthday
                  : "Null"
                  }}
                </td>
                <td class="p-4 text-table">
                  {{ (hospital.information
                  ? hospital.information.age
                  : "Null") + "歳"
                  }}
                </td>
                <td class="p-4 text-table">
                  {{ hospital.information && hospital.information.sex === 0
                  ? "女性"
                  : hospital.information && hospital.information.sex === 1
                    ? "男性"
                    : "無回答"
                  }}
                </td>
                <td class="p-4 text-table">
                  {{ hospital.exam | filterSurveyType1 }}
                </td>
                <td class="p-4 text-table">
                  {{ hospital.exam | filterSurveyType2 }}
                </td>
                <td class="p-4 text-table">
                  {{ hospital.exam | filterSurveyType3 }}
                </td>
                <td class="p-4 text-table">
                  {{ hospital ? hospital.frequency : "" }}回/週
                </td>
                <td class="p-4 text-table">
                    <span v-if="hospital && hospital.is_used === 0" class="badge badge-pill badge-soft-success font-size-11">{{ "(入会日: " +
                    new Date().getFullYear() +
                    "/" +
                    new Date().getMonth() +
                    "/" +
                    new Date().getDay() +
                    ")"
                      }}</span>
                  <span v-if="hospital && hospital.is_used === 1" class="badge badge-pill badge-soft-success font-size-11">{{ hospital.created_at | fomatDate }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <ul class="pagination pagination-rounded justify-content-center mt-4">
                <li class="page-item">
                  <a href="#" @click="OnPagination(page > 1 ? page - 1 : 1)" class="page-link">
                    <i class="mdi mdi-chevron-left"></i>
                  </a>
                </li>
                <li v-for="n in paginationPages" :key="n" class="page-item" :class="n === page ? 'active' : ''">
                  <a href="#" @click="OnPagination(n)" class="page-link" :class="n === page ? 'btn-lyg' : ''">{{ n }}</a>
                </li>
                <li class="page-item">
                  <a href="#" @click="OnPagination(page === paginationPages ? paginationPages : page + 1)" class="page-link">
                    <i class="mdi mdi-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </div>
            <span class="text-muted">{{ gPaginationHospital.total }}の{{ gPaginationHospital.from }}-{{ gPaginationHospital.to }}を表示しています</span>
          </div>
        </div>
      </Loader>
    </div>
  </Layout>
</template>
